import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, useHistory } from 'react-router-dom';
import { IconButton, Icon, Grid, Typography, FormGroup, FormControl, FormLabel, FormControlLabel, Checkbox, Button, Tooltip, Box, CircularProgress } from '@material-ui/core';

import { getVersoes, excluirVersao } from '../../store/actions/versaoApp';
import TituloPagina from '../../components/layout/TituloPagina';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';
import { toggleShowDialog } from '../../store/actions/dialog';

const VersaoApp = props => {
    const history = useHistory();
    const [processingMessage, setProcessingMessage] = useState('');
    const [showDialogExcluirVersao, setShowDialogExcluirVersao] = useState(false);
    const {
        user,
        getVersoes,
        excluirVersao,
        versoes,
        loading,
        processing,
        toggleShowDialog
    } = props;
    const { perfis } = user;

    useEffect(_ => {
        getVersoes();
    }, []);

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '70px',
            sortable: true,
        },
        {
            name: 'Versão Mais Recente',
            selector: (row) => row.versaoMaisRecente,
            sortable: true,
            width: '250px',
        },
        {
            name: 'Versão Mínima Obrigatória',
            selector: (row) => row.versaoMinimaObrigatoria,
            sortable: true,
            width: '250px',
        },
        {
            name: 'Data de Cadastro',
            selector: (row) => row.dataCadastro,
            sortable: true,
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Editar' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="editar" size='small' color='secondary' onClick={() => handleEditarVersaoDoApp(row.id)}><Icon>edit</Icon></IconButton>
                    </Tooltip>
                    <Tooltip title='Excluir' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="excluir" size='small' color='secondary' onClick={() => handleExcluirVersao(row.id)} ><Icon>delete</Icon></IconButton>
                    </Tooltip>
                </>
            ),
            width: '100px'
        }
    ];

    const handleEditarVersaoDoApp = (id) => {
        history.push({
            pathname: '/versoes-app/editar-versao',
            state: {
                versaoAppId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleExcluirVersao = (idVersao) => {
        toggleShowDialog(idVersao);
        setShowDialogExcluirVersao(true);
    }

    const handleCancelarExcluir = () => {
        setShowDialogExcluirVersao(false);
    }

    const handleConfirmarExcluir = (idVersao) => {
        setShowDialogExcluirVersao(false);
        setProcessingMessage('Excluindo...');
        excluirVersao(idVersao);
        setProcessingMessage('');
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <Box sx={{ height: '70vh' }}>
                <TituloPagina titulo='Versões do App' subtitulo={new Date().toLocaleString('pt-BR')} />

                <DataTableComponent
                    columns={columns}
                    data={versoes}
                    visibleSearch={versoes && versoes.length > 0}
                    camposParaBusca={['versaoMaisRecente', 'versaoMinimaObrigatoria']}
                />
                <Grid container >
                    <Button variant='contained' color='secondary' href='/versoes-app/cadastrar-versao' >Cadastrar Versão</Button>
                </Grid>
            </Box>

            <DialogAlert
                title='Excluir Versão do App'
                okButton={true}
                okButtonClick={handleConfirmarExcluir}
                cancelButtonClick={handleCancelarExcluir}
                labelOkButton='Confirmar'
                cancelButton={true}
                labelCancelButton='Cancelar'
                openDialog={showDialogExcluirVersao}
            >
                Você tem certeza que quer excluir a versão?
            </DialogAlert>
        </>
    )
}

const mapStateToProps = state => ({
    user: state.auth.user,
    versoes: state.versaoApp.versoes,
    loading: state.versaoApp.loading,
    processing: state.versaoApp.processing,
    idDialogShow: state.dialog.idDialogShow,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getVersoes,
    excluirVersao,
    toggleShowDialog,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(VersaoApp);